var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsYtube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_15681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 6.58589V23.4149C30 27.0521 27.0521 30 23.415 30H6.58651C2.94865 30 0 27.0513 0 23.4133V6.58589C0 2.94871 2.94865 0 6.58497 0H23.415C27.0521 0 30 2.94794 30 6.58512V6.58589Z",
    fill: "#F33535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19971 14.9997C5.19971 16.4968 5.27202 17.9923 5.41799 19.4879C5.54504 21.2006 6.53916 22.3049 8.00361 22.4966C9.32007 22.6946 12.0401 22.7839 14.9974 22.7631C17.9547 22.7839 20.6748 22.6946 21.9913 22.4966C23.4557 22.3049 24.4498 21.2006 24.5769 19.4879C24.7222 17.9923 24.7952 16.496 24.7952 14.9997C24.7952 13.5026 24.7229 12.0071 24.5769 10.5116C24.4498 8.79888 23.4557 7.69455 21.9913 7.5028C20.6748 7.30488 17.9547 7.21555 14.9974 7.23634C12.0401 7.21555 9.32007 7.30488 8.00361 7.5028C6.53916 7.69455 5.54504 8.79888 5.41799 10.5116C5.27269 12.0071 5.19971 13.5034 5.19971 14.9997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7769 11.6504L18.6256 15.0003L12.7769 18.3503V11.6504Z",
    fill: "#F33535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_15681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsYtube);
export default __webpack_public_path__ + "static/media/sns_ytube.1914637f23a4b87f3433a7a52e6e8c19.svg";
export { ForwardRef as ReactComponent };